import TimeDisplay from './styled';

export default TimeDisplay;
